export const UPDATE_LOGIN_STATE = 'UPDATE_LOGIN_STATE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const UPDATE_FORGOTTEN_PASS_STATE = 'UPDATE_FORGOTTEN_PASS_STATE';
export const SENT_FORGOTTEN_PASS = 'SENT_FORGOTTEN_PASS';
export const UPDATE_RESET_PASSWORD_STATE = 'UPDATE_RESET_PASSWORD_STATE';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const SET_USER_TERMS = 'SET_USER_TERMS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_LOADING = 'SET_LOADING';
